<template>
  <v-card>

<v-card-title color="red">
  <h4>{{ data.name }}</h4>
</v-card-title>
<v-divider/>
<v-card-text>
</v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ['data'],
  data: () => ({
    properties: {}
  })

}
</script>
<style>
.mapboxgl-popup-content {
  padding: unset;
}
</style>
